export default "__VITE_ASSET__BbDSz8ro__"